import React from "react";

const SeeAllButton = ({link, ...rest}) => {
  return (
    <div className="see-all-button" {...rest}>
      <a href={link}>
        {I18n.t('see_all')}
      </a>
    </div>
  )
}

export default SeeAllButton;